import clsx from "clsx";
import type React from "react";

export const AssignmentStep: React.FC<{
  number: number;
  title: React.ReactNode;
  description: React.ReactElement;
  children: React.ReactNode;
  className?: string;
}> = ({ number, title, description, children, className }) => {
  return (
    <div className={clsx("relative overflow-hidden p-6 md:p-8", className)}>
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-x-1/4 inset-y-0 -rotate-6 skew-x-6 scale-125"
      >
        {children}
      </div>
      <div className="relative space-y-4">
        <div className="font-mono max-md:text-sm">
          {number.toString().padStart(2, "0")}.
        </div>
        <div className="space-y-2">
          <h2 className="title title-md">{title}</h2>
          <div className="max-w-lg space-y-2 md:text-lg">{description}</div>
        </div>
      </div>
    </div>
  );
};
